export default __webpack_public_path__ + "static/media/DSC_7625.4b03d75c.jpg";